import React, { useEffect } from 'react';
import { Redirect, Route, RouteProps } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'stores';
import { UserInfoState, fetchUserInfo } from 'stores/userInfo';
import { EHttpStatusCode } from 'helpers/type';
import { ERoutePath } from 'router';
import { track } from 'telemetry';
import { ETelemetryActionsAndLabels, ETelemetryNames } from 'telemetry/type';
import { isBusinessIdChanged } from 'helpers/tools';
import { auth } from '@my-account/tools';
import LoadingWrapper from 'components/LoadingWrapper';
import AppErrorWrapper from 'pages/AppErrorWrapper';

export const AuthRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
    const { isLoading, isError, error } = useSelector<RootState, UserInfoState>(state => state.userInfo);
    const isAuthorizeError = isError && error?.status === EHttpStatusCode.FORBIDDEN;
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchUserInfo());
    }, [dispatch]);

    const shouldShowLoadingWrapper = (error && error.message === auth.LOGIN_ERROR_MESSAGE) || isLoading;
    useEffect(() => {
        isAuthorizeError &&
            track(ETelemetryNames.ErrorPage, {
                action: ETelemetryActionsAndLabels.View,
                label: ETelemetryActionsAndLabels.View,
                viewData: {
                    reason: error?.message,
                },
            });
    }, [error, isAuthorizeError]);

    return (
        <LoadingWrapper isLoading={shouldShowLoadingWrapper}>
            <AppErrorWrapper>
                <Route
                    {...rest}
                    render={({ location }) => {
                        if (isBusinessIdChanged(location.search)) {
                            window.location.reload();
                        }
                        return isAuthorizeError ? <Redirect to={ERoutePath.Unauthorized} /> : children;
                    }}
                />
            </AppErrorWrapper>
        </LoadingWrapper>
    );
};

export default AuthRoute;
